module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_100-1ad55a55b13b0e964edca349ec00b76d.png";